import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import PaymentIcon from "@material-ui/icons/Payment";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import MoneyIcon from "@material-ui/icons/Money";
import NumberFormat from "react-number-format";
import TimerIcon from "@material-ui/icons/Timer";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { actions as shoppingCartActions } from "../../../redux/actions/shoppingCart";
import styles from "../../../styles/global-styles";
import NumberFormatCustom from "../../stateless/NumberFormatCustom";
import { useHistory } from "react-router-dom";
import { SellService } from "../../../services/sell.service";
import CartResume from "./CartResume";
import { getTotalCost, validateChips } from "./utils-shoppingCart";
import { ChipService } from "../../../services/chip.service";
import ClientInfo from "./ClientInfo";
import { createTicketReport } from "../reports/TicketReport";
import { PhonePlanService } from "../../../services/phonePlan.service";
import { ClientService } from "../../../services/client.service";

const useStyles = makeStyles(() => ({
  paper: {
    height: "auto",
    width: "auto",
    background: "white",
    marginTop: 50,
  },
  title: {
    fontWeight: 700,
    color: "#1C2668",
    opacity: 0.5,
    fontSize: 24,
    padding: 14,
  },
  box: {
    margin: "40px 0px 10px 20px",
  },
  label: {
    marginBottom: "1.5vh",
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "100%",
      border: "0.2px solid #f2f2f2",
      fontSize: 20,
    },
  },
  body: styles.body,
  header: styles.header,
  cashPayment: styles.cashPayment,
  creditPayment: styles.creditPayment,
  debitPayment: styles.debitPayment,
  transfPayment: styles.transfPayment,
  pendingPayment: styles.pendingPayment,
}));

const ShoppingCartBox = ({
  addAlert,
  detailAlert,
  paymentInfo,
  emptyCart,
  shoppingCart: { cart },
}) => {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    setPaymentArray(paymentInfo);
  }, [paymentInfo]);

  const [paymentOption, setpaymentOption] = useState(undefined);
  const [price, setPrice] = useState(null);
  const [paymentArray, setPaymentArray] = useState(paymentInfo);
  const [numbersAssociateToIccid, setnumbersAssociateToIccid] = useState([]);

  const buildMessageAlert = (showAlert, severity, message, time = 3000) => {
    addAlert({ showAlert });
    detailAlert({
      severity,
      message,
      time,
    });
  };

  const handlePaymentOption = (option) => {
    setPrice(null);
    setpaymentOption(option);
    const copyPaymentBulk = [...paymentArray];
    paymentArray.forEach((_, i) => {
      copyPaymentBulk[i] = { ...copyPaymentBulk[i], paymentMethodId: option };
    });
    setPaymentArray(copyPaymentBulk);
  };

  const handleClientFound = async (addclient, clientObject) => {
    const clientId = clientObject.id;
    if (addclient) {
      const copyPaymentArray = [...paymentArray];

      /** Filter cart for some phone plan product
       * and update clientId
       */
      const phonePlanProduct = Object.values(cart).filter(
        (item) => item.phonePlanId !== null
      );
      if (phonePlanProduct && phonePlanProduct.length) {
        try {
          const phonePlanIds = phonePlanProduct.map((item) => item.phonePlanId);
          await PhonePlanService.updateBulkPhonePlan(
            { clientId },
            phonePlanIds
          );
          // console.log("phonePlanIds", phonePlanIds);
        } catch (error) {
          buildMessageAlert(true, "error", error.msgs);
        }
      }

      copyPaymentArray.forEach((item, i) => {
        copyPaymentArray[i] = { ...item, clientId };
      });
      setPaymentArray(copyPaymentArray);
    } else {
      const copyPaymentArray = [...paymentArray];
      copyPaymentArray.forEach((item, i) => {
        delete item.clientId;
      });
      setPaymentArray(copyPaymentArray);
    }
  };

  const handlePayment = async () => {
    const { validationCorrect, text } = validateChips(
      cart,
      numbersAssociateToIccid
    );
    if (!validationCorrect) {
      buildMessageAlert(true, "warning", text);
      return;
    }

    try {
      // console.log("paymentArray", paymentArray);
      // console.log("cart", cart);
      if (paymentOption === 1 && !price) {
        buildMessageAlert(
          true,
          "error",
          "La cantidad recibida debe ser mayor 0"
        );
        return;
      }
      const { data } = await SellService.createBulkSell(paymentArray);
      // console.log("sell data", data);

      if (numbersAssociateToIccid.length) {
        await ChipService.updateNumberByBulk(numbersAssociateToIccid);
      }

      // /** generate PDF sell ticket */
      await createTicketReport(paymentArray, cart);
      setTimeout(() => {
        emptyCart();
        history.push("/dashboard/inventario/nueva-venta");
      }, 3000);
      buildMessageAlert(true, "success", "Venta generada exitosamente");
    } catch (error) {
      console.log("error", error);
      if (error.status === 409) {
        const {
          data: { message, products },
        } = error;
        buildMessageAlert(true, "error", message + products, 8000);
      } else {
        buildMessageAlert(
          true,
          "error",
          error.msgs ? error.msgs : "Error al generar la venta"
        );
      }
    }
  };

  const calculateChangeReturn = () => {
    const total = getTotalCost(cart);
    return (price || 0) - total < 0 ? 0 : price - total;
  };

  const handleNumbersAssociateToIccid = (chipsArray) =>
    setnumbersAssociateToIccid(chipsArray);

  const handleItemRemoved = () => {
    if (Object.values(cart).some((item) => item.balanceTransferId)) {
      const balanceTransfer = Object.values(cart).map(
        (item) => item.balanceTransferId === 5
      );
      console.log("balanceTransfer", balanceTransfer);
    }
    setPaymentArray([]);
    setpaymentOption(null);
  };

  return (
    <Grid container direction="row" spacing={4} alignItems="stretch">
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <CartResume
          chipNumbers={handleNumbersAssociateToIccid}
          itemRemoved={() => handleItemRemoved()}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={8} lg={8}>
        <Paper className={classes.paper}>
          <ClientInfo clientInfo={handleClientFound} addClient />

          <div style={{ display: "inline-flex", marginTop: 20 }}>
            <Typography variant="h4" component="h4" className={classes.title}>
              Cobro
            </Typography>
          </div>

          <Grid
            container
            direction="row"
            justify="space-around"
            alignItems="center"
          >
            <Grid item container>
              <div
                style={{
                  margin: "10px 20px",
                }}
                className={classes.body}
              >
                Método de pago
              </div>
            </Grid>
            <Grid item>
              <Button
                className={classes.cashPayment}
                variant="contained"
                color="primary"
                type="submit"
                disabled={paymentOption === 1}
                onClick={() => handlePaymentOption(1)}
                endIcon={<AttachMoneyIcon color="secondary" />}
              >
                Efectivo
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.debitPayment}
                variant="contained"
                color="primary"
                disabled={paymentOption === 2}
                type="submit"
                onClick={() => handlePaymentOption(2)}
                endIcon={<PaymentIcon color="secondary" />}
              >
                Tarjeta de débito
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.creditPayment}
                variant="contained"
                color="primary"
                type="submit"
                disabled={paymentOption === 3}
                onClick={() => handlePaymentOption(3)}
                endIcon={<PaymentIcon color="secondary" />}
              >
                Tarjeta de crédito
              </Button>
            </Grid>
            <Grid item>
              <Button
                className={classes.transfPayment}
                variant="contained"
                color="primary"
                type="submit"
                disabled={paymentOption === 4}
                onClick={() => handlePaymentOption(4)}
                endIcon={
                  <>
                    <MonetizationOnIcon color="secondary" />{" "}
                    <MoneyIcon color="secondary" />
                  </>
                }
              >
                Transf. electrónica
              </Button>
            </Grid>
          </Grid>

          {Object.values(cart).some((item) => item.balanceTransferId) && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ marginTop: 40 }}
            >
              <Grid item>
                <Button
                  className={classes.pendingPayment}
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={paymentOption === 5}
                  onClick={() => handlePaymentOption(5)}
                  endIcon={
                    <>
                      <MonetizationOnIcon color="secondary" />{" "}
                      <TimerIcon color="secondary" />
                    </>
                  }
                >
                  Pendiente de pago
                </Button>
              </Grid>
            </Grid>
          )}

          {paymentOption === 1 && (
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <Box className={classes.box}>
                  <Typography
                    variant="body2"
                    component={"div"}
                    className={classes.label}
                  >
                    Cantidad recibida
                  </Typography>
                  <TextField
                    name="price"
                    className={classes.textField}
                    value={price || ""}
                    onChange={(e) => setPrice(e.target.value)}
                    variant="outlined"
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Box>
              </Grid>
              <Grid item style={{ marginLeft: 20 }}>
                <div className={classes.header}>
                  Cambio: {"   "}
                  <NumberFormat
                    value={calculateChangeReturn()}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </div>
              </Grid>
            </Grid>
          )}
          <Grid container style={{ margin: 40 }}></Grid>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={12}>
              <Button
                style={{ margin: "10px 20px", width: "90%" }}
                variant="contained"
                onClick={() => {
                  handlePayment();
                }}
                disabled={!paymentOption}
                color="primary"
              >
                Pagar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
  removeItemFromCart: shoppingCartActions.removeItemFromCart,
  emptyCart: shoppingCartActions.emptyCart,
};

const mapStateToProps = (state) => ({
  shoppingCart: state.shoppingCart,
});

export default connect(mapStateToProps, dispatch)(ShoppingCartBox);
